import * as React from 'react'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import { Features } from 'config/feature'
import { Feature } from 'components/feature/feature.setup'
import { Spinner } from 'components/spinner/spinner.component'
import { Headline } from 'pages/settings/default-search-filters/components/custom-range-modal/custom-range-modal.styles'

const fallback = (
  <Spinner>
    <Headline>loading...please wait</Headline>
  </Spinner>
)

const Dashboard = React.lazy(
  () => import(/* webpackChunkName: "dashboard" */ '../../pages/dashboard/Dashboard.component')
)

const Settings = React.lazy(
  () => import(/* webpackChunkName: "settings" */ '../../pages/settings/Settings.component')
)

const Glossaries = React.lazy(
  () => import(/* webpackChunkName: "glossaries" */ '../../pages/glossaries/Glossaries.component')
)

const VespaSettings = React.lazy(
  () =>
    import(/* webpackChunkName: "vespa-settings" */ '../../pages/vespa-settings/Settings.component')
)

// TODO: Check if page title change is required when adding new routes
export const Routes: React.FC = () => (
  <Router>
    <React.Suspense fallback={fallback}>
      <Switch>
        <Route exact path="/" component={Dashboard} />
        <Route path="/settings" component={Settings} />
        <Route path="/glossaries" component={Glossaries} />
        <Feature feature={Features.vespaSettings}>
          <Route path="/vespa-settings" component={VespaSettings} />
        </Feature>
      </Switch>
    </React.Suspense>
  </Router>
)
